export default __webpack_public_path__ + "static/media/rangmanch1.8a44d8ff.jpg";